import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';
export default function save(_ref) {
  let {
    attributes: {
      height,
      width
    }
  } = _ref;
  return createElement("div", useBlockProps.save({
    style: {
      height,
      width
    },
    'aria-hidden': true
  }));
}
//# sourceMappingURL=save.js.map